import { workersSlider } from "./sliders";
import { Splide } from "@splidejs/splide";

export default class WorkersSlider {
    private section: HTMLElement;
    private workersWrapper: HTMLElement | null;
    private breakpoint: string;
    private slider: Splide | null = null;

    constructor(section: HTMLElement) {
        this.section = section;
        this.workersWrapper = this.section.querySelector("#workers-slider");
        this.breakpoint = "(max-width: 1480px)";

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.workersWrapper) return;

        this.slider = workersSlider(this.workersWrapper);

        if (!window.matchMedia(this.breakpoint).matches) this.slider.destroy();
        window.matchMedia(this.breakpoint).addEventListener("change", this.changeSliderState);
    };

    private changeSliderState = ({ matches }: MediaQueryListEvent) => {
        if (!this.workersWrapper) return;

        matches ? this.slider?.mount() : this.slider?.destroy();
    };
}
